import styled from "@emotion/styled";
import { Box, Tab, Tabs } from "@mui/material";
import { Article } from "lib/articles";
import { useEffect, useRef, useState } from "react";
import { trackArticle, trackShowMoreArticles } from "reusable/ChargeGTM";
import { useIsDesktop } from "ui";
import TabPanel from "ui/TabPanel";
import { sharedColors } from "ui/theme/colors";
import ArticleCard from "./ArticleCard";
import MoreArticlesButton from "./MoreArticlesButton";

const StyledTabs = styled(Tabs)`
 & .MuiTabs-flexContainer {
    width: 100%;
    display: grid;
    grid-template-columns: repeat(3, 1fr);
  }
    padding-bottom: 20px;
        button {
        max-width: none;
    }
`;
const StyledGridContainer = styled.div<{ allArticlesShown: boolean }>`
  display: grid;
  grid-template-columns: 1fr;
  gap: 20px;
  width: 100%;

    ${(props) => props.theme.breakpoints.up("md")} {
    grid-template-columns: repeat(3, 1fr);
    ${(p) => p.allArticlesShown && "padding-bottom: 50px;"}
    }
`;
const StyledButtonWrapepr = styled.div`
  display: flex;
  justify-content: center;
  padding-bottom: 60px;
  font-weight: 500;
      ${(props) => props.theme.breakpoints.up("md")} {
     padding-bottom: 80px;
    }
`;
const StyledTab = styled(Tab)`
     font-size: 18px;
     line-height    : 20px;
      ${(props) => props.theme.breakpoints.up("md")} {

    }
`;
export type ArticlesCategories = {
    allArticles: Article[],
    commercialArticles: Article[],
    publicArticles: Article[],
}
type Props = {
    articlesByCategory: ArticlesCategories
    moreArticles: Article[]
}

const tabNames = ["כל הכתבות", "מסחרי", "ציבורי"];

function ArticleTabMenu({ articlesByCategory, moreArticles }: Props) {

    const [tabIndex, setTabIndex] = useState(0);
    const [itemsLimit, setItemsLimit] = useState(5)
    const isDesktop = useIsDesktop()

    // Ref to track the first newly added article
    const firstNewArticleRef = useRef<HTMLAnchorElement | null>(null);

    useEffect(() => {
        setItemsLimit(isDesktop ? 12 : 5)
    }, [isDesktop])


    const handleChange = (event: React.SyntheticEvent, newValue: number) => {
        setTabIndex(newValue);
    };

    const currentArticlesInTab = Object.values(articlesByCategory)[tabIndex]
    const showMoreArticlesButton = currentArticlesInTab.length > itemsLimit

    const handleShowMoreArticles = () => {
        setItemsLimit(limit => limit + 6)
        trackShowMoreArticles()
    }

    return (
        <>
            <Box sx={{ width: '100%', paddingBottom: 2 }}>
                <StyledTabs value={tabIndex} onChange={handleChange} aria-label="סינון מידע שימוש לפי נושא">
                    {tabNames.map((tabName, index) =>
                        <StyledTab
                            label={tabName}
                            sx={{ borderBottom: `${index === tabIndex ? 4 : 2}px solid ${index === tabIndex ? sharedColors.orange : sharedColors.gray}` }}
                        />
                    )}
                </StyledTabs>
                {Object.values(articlesByCategory).map((articles, index) => {
                    return (
                        <TabPanel value={tabIndex} index={index}>
                            <StyledGridContainer
                                allArticlesShown={!showMoreArticlesButton}>
                                {articles.slice(0, itemsLimit).map((article: Article, index) => {
                                    const addedTrackArticle = () => {
                                        trackArticle(tabNames[tabIndex], (index + 1).toString(), article.name)
                                    }
                                    // If this is the first article of the newly added ones, attach the ref
                                    const refFirstNewArticle = index === itemsLimit - 5 ? firstNewArticleRef : null;
                                    return <ArticleCard
                                        article={article}
                                        position={index}
                                        onClickAddedLogic={addedTrackArticle}
                                        ref={refFirstNewArticle}
                                    />
                                })}
                            </StyledGridContainer>
                        </TabPanel>
                    )
                })}
            </Box>
            {showMoreArticlesButton &&
                <StyledButtonWrapepr>
                    <MoreArticlesButton onClickHandler={handleShowMoreArticles} />
                </StyledButtonWrapepr>}
        </>
    );
}
export default ArticleTabMenu;
